import React from "react";

const NodesIcon = ({ size, color }) => {
  return (
    <svg
      width="35"
      height="27"
      viewBox="0 0 35 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.3326 21.1831L17.9058 7.02458L18.6128 6.50391L29.0396 20.6624L28.3326 21.1831Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.16324 22.061L16.5901 7.90251L15.8831 7.38184L5.45623 21.5404L6.16324 22.061Z"
        fill="white"
      />
      <path
        d="M11.5714 21.2144C11.5714 24.4098 8.98108 27.0001 5.78571 27.0001C2.59035 27.0001 0 24.4098 0 21.2144C0 18.0191 2.59035 15.4287 5.78571 15.4287C8.98108 15.4287 11.5714 18.0191 11.5714 21.2144Z"
        fill="white"
      />
      <path
        d="M23.1428 5.78571C23.1428 8.98108 20.5525 11.5714 17.3571 11.5714C14.1618 11.5714 11.5714 8.98108 11.5714 5.78571C11.5714 2.59035 14.1618 0 17.3571 0C20.5525 0 23.1428 2.59035 23.1428 5.78571Z"
        fill="white"
      />
      <path
        d="M34.7143 21.2144C34.7143 24.4098 32.1239 27.0001 28.9285 27.0001C25.7332 27.0001 23.1428 24.4098 23.1428 21.2144C23.1428 18.0191 25.7332 15.4287 28.9285 15.4287C32.1239 15.4287 34.7143 18.0191 34.7143 21.2144Z"
        fill="white"
      />
    </svg>
  );
};

export default NodesIcon;
